import { render, staticRenderFns } from "./DatatableLogs.vue?vue&type=template&id=0472115c"
import script from "./DatatableLogs.vue?vue&type=script&lang=js"
export * from "./DatatableLogs.vue?vue&type=script&lang=js"
import style0 from "./DatatableLogs.vue?vue&type=style&index=0&id=0472115c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports